module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eYXGN"))).then(() => parcelRequire('3a9aZ'));